'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _advertService = require('./advertService');

var _brandService = require('./brandService');

var _buyerBaseService = require('./buyerBaseService');

var _cartService = require('./cartService');

var _categoryService = require('./categoryService');

var _commonService = require('./commonService');

var _dialogService = require('./dialogService');

var _discounttypeService = require('./discounttypeService');

var _documentLibraryService = require('./documentLibraryService');

var _exceptionService = require('./exceptionService');

var _localizer = require('./localizer');

var _newsService = require('./newsService');

var _newsOverviewService = require('./newsOverviewService');

var _orderService = require('./orderService');

var _productService = require('./productService');

var _queryStringHelper = require('./queryStringHelper');

var _sellerService = require('./sellerService');

var _sellerCategoryService = require('./sellerCategoryService');

var _screenService = require('./screenService');

var _tenantService = require('./tenantService');

var _textBuilder = require('./textBuilder');

var _userService = require('./userService');

var _productOverviewService = require('./productOverviewService');

var _helpService = require('./helpService');

var _partnershipsService = require('./partnershipsService');

var _contractService = require('./contractService');

var _vaccinesService = require('./vaccinesService');

var _reservationCampaignService = require('./reservationCampaignService');

var _coronaService = require('./coronaService');

var _outletService = require('./outletService');

var _rentalProductsService = require('./rentalProductsService');

var _packagesService = require('./packagesService');

var _parcelService = require('./parcelService');

var _security = require('../../blocks/security');

var _security2 = _interopRequireDefault(_security);

var _certificatesService = require('./certificatesService');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import {authServiceProvider} from './authService';
var _module = _angular2.default.module('app.services', [_security2.default]).factory('advertService', _advertService.advertService).factory('brandService', _brandService.brandService).factory('buyerBaseService', _buyerBaseService.buyerBaseService).factory('cartService', _cartService.cartService).factory('categoryService', _categoryService.categoryService).factory('common', _commonService.commonService).factory('dialogService', _dialogService.dialogService).factory('discounttypeService', _discounttypeService.discounttypeService).factory('documentLibraryService', _documentLibraryService.documentLibraryService).factory('exceptionService', _exceptionService.exceptionService).factory('localizer', _localizer.localizer).factory('newsService', _newsService.newsService).factory('newsOverviewService', _newsOverviewService.newsOverviewService).factory('orderService', _orderService.orderService).factory('productService', _productService.productService).factory('queryStringHelper', _queryStringHelper.queryStringHelper).factory('sellerService', _sellerService.sellerService).factory('sellerCategoryService', _sellerCategoryService.sellerCategoryService).factory('screenService', _screenService.screenService).factory('tenantService', _tenantService.tenantService).factory('textBuilder', _textBuilder.textBuilder).factory('userService', _userService.userService).factory('productOverviewService', _productOverviewService.productOverviewService).factory('helpService', _helpService.helpService).factory('partnershipsService', _partnershipsService.partnershipsService).factory('contractService', _contractService.contractService).factory('outletService', _outletService.outletService).factory('rentalProductsService', _rentalProductsService.rentalProductsService).factory('vaccinesService', _vaccinesService.vaccinesService).factory('reservationCampaignService', _reservationCampaignService.reservationCampaignService).factory('coronaService', _coronaService.coronaService).factory('certificatesService', _certificatesService.certificatesService).factory('packagesService', _packagesService.packagesService).factory('parcelService', _parcelService.parcelService);
//.provider('authService', authServiceProvider);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./common/services/index.js
// module id = 814
// module chunks = 0